/** The clinic's raw material, for a contact with the upload flag: file footage
 *  by doctor, procedure and date. No usage details, no delete. */
import { useAuth } from '@/hooks/use-auth';
import { MaterialLibrary } from '@/pages/material';

export default function PortalMaterialPage() {
  const { user } = useAuth();
  if (!user?.client_id) return <div className="text-sm text-muted">No clinic on this login.</div>;
  if (!user.can_upload_material && user.portal_scope !== 'uploads') return <div className="text-sm text-muted">Uploading material has not been switched on for your login. Ask KAF PRO.</div>;
  return <MaterialLibrary clientId={user.client_id} portal />;
}
